// Utils
var resizer = require('../lib/fullResizer');
var canvastools = require('../lib/canvas');
var countdownFactory = require("../lib/countdown");

var factory = function (options) {
  var $wrapper = options.$wrapper;
  var $html = options.$html;
  var canvas = options.canvas;
  var matchShape = options.matchShape;
  var failView = options.failView;
  var successView = options.successView;
  var video = options.video;

  var countdownCanvas = $html.find('#countdown').get(0);

  var view = function () {
    resizer.watch(canvas);
    canvastools.sketch(canvas);

    var challengeFactory = function () {

      return new Promise(function (resolve, reject) {

          var checkMatch = function (e) {
            var path = e.detail;
            var res = canvastools.match(path, matchShape) ? path : "challenge:fail";
            resolve(res);

            canvas.removeEventListener("sketch:finished", checkMatch);
          };

          canvas.addEventListener("sketch:finished", checkMatch);

        });
    };

    var raceFactory = function () {
      $wrapper.off();

      $wrapper.html($html);

      var countdown = countdownFactory(countdownCanvas);

      var resetView = function () {
        return new Promise(function (resolve, reject) {

          setTimeout(function () {
            $wrapper.addClass('in');
            $html.find(".icon").on('transitionend webkitTransitionEnd oTransitionEnd', function () {
              resolve();
            });

            // In case our transition end event doesn't fire, we resolve manually.
            setTimeout(function () {
              resolve();
            }, 1000);
          }, 250);
        });
      };

      var race = function () {
        return Promise.race([
            countdown.countdown(5000),
            challengeFactory()
          ])
          .then(function (result) {
            $wrapper.html('')
              .removeClass('in');
            if (result === "challenge:fail"){
              return failView()
                      .then(raceFactory)
                      .catch(console.log.bind(console));
            } else {
              return successView(result);
            }
          })
          .catch(console.log.bind(console));
      };

      return Promise.resolve()
              .then(resetView)
              .then(race);
    };

    return raceFactory();
  };

  return view;
};

module.exports = factory;
